module.exports = __webpack_public_path__ + "img/icon_temp_item.b119070f.png";